document.addEventListener('click', (e) => {
  if (!e.target.closest('.after-pay .announcement--anchor-link')) return;
  e.preventDefault();
  const tryClick = () => {
    return [...document.querySelectorAll('square-placement, afterpay-placement')].some(el => {
      const t = el.shadowRoot?.querySelector('.afterpay-logo');
      return t && (t.click(), true);
    });
  };
  if (tryClick()) return;
  const observer = new MutationObserver(() => {
    if (tryClick()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
});

function applyOGTooltipFix() {
  document.querySelectorAll('og-tooltip').forEach((tooltip) => {
    const shadow = tooltip.shadowRoot;
    if (!shadow || shadow.querySelector('#og-tooltip-fix')) return;
 
    const style = document.createElement('style');
    style.id = 'og-tooltip-fix';
    style.textContent = `
	  @media (max-width: 767px) {
        #tooltip-content::after {
          left: calc(72% + 30px) !important;
          margin-left: 0 !important;
        }
	    #tooltip-content {
          left: auto !important;
		      right: 0 !important;
        }
	  }
    `;
    shadow.appendChild(style);
  });
}
 
applyOGTooltipFix();
setInterval(applyOGTooltipFix, 1000);


// Change for custom PDP add to cart widget
(function () {
  'use strict';
  function isSubscriptionItem(item) {
    return item.selling_plan_allocation != null &&
           item.properties?._gift_product !== 'true';
  }
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-element');
      // Use data-view="drawer" to avoid matching the cart-page containers
      // (cart-desktop / cart-mobile) which appear earlier in the DOM on /cart.
      const currentDrawer = document.querySelector('cart-element[data-view="drawer"]');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
      globalThis.dispatchEvent(new Event('theme:cart:updated'));
    } catch (err) {
      console.error('[OG] Cart drawer refresh failed:', err);
    }
  }
  async function waitForCartUpdate(previousCount, maxWaitMs, intervalMs, subCheck) {
    const deadline = Date.now() + maxWaitMs;
    while (Date.now() < deadline) {
      await new Promise(function (resolve) { setTimeout(resolve, intervalMs); });
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        if (cart.item_count !== previousCount) return;
        // Also resolve when subscription status changes (e.g. one-time purchase
        // selection removes selling_plan — item_count stays the same).
        if (subCheck?.(cart)) return;
      } catch (error_) {
        console.warn('Polling request failed, will retry.', error_);
      }
    }
  }
  let refreshPending = false;
  function onOgSelectChange() {
    if (refreshPending) return;
    refreshPending = true;
    globalThis.__ogRefreshPending = true; // keeps handleCartUpdate from removing overlay too early
    (async function () {
      try {
        let previousCount = null;
        let previousSubStatus = null;
        try {
          const snap = await fetch('/cart.js');
          const cart = await snap.json();
          previousCount = cart.item_count;
          // Capture subscription status so waitForCartUpdate can resolve on plan change,
          // not just item_count change (one-time purchase doesn't change item count).
          previousSubStatus = (cart.items || []).some(isSubscriptionItem);
        } catch (error_) {
          console.warn('Polling failed:', error_);
        }
        const cartDrawerEl = document.querySelector('drawer-element');
        cartDrawerEl?.classList.add('opacity-delay');
        await Promise.race([
          new Promise(function (resolve) {
            globalThis.addEventListener('og:cart:updated', resolve, { once: true });
          }),
          previousCount === null
            ? new Promise(function (resolve) { setTimeout(resolve, 1000); })
            : waitForCartUpdate(previousCount, 2000, 1000, function (cart) {
                if (previousSubStatus === null) return false;
                return (cart.items || []).some(isSubscriptionItem) !== previousSubStatus;
              }),
        ]);
        cartDrawerEl?.classList.remove('opacity-delay');
        // opacity-delay is intentionally NOT removed here.
        // custom-gift-progress-bar.js handleCartUpdate() removes it in its finally
        // block, after updateGiftProducts() + refreshCartSections() both complete
        // and data-is-gift items are fully updated in the DOM.
        // On the /cart page the theme's own Cart.addRefreshListener handles
        // re-rendering cart-desktop and cart-mobile sections. Calling
        // refreshCartDrawer() here would (even with the drawer-scoped selector)
        // leave the cart-page sections stale. Let the theme handle it instead.
        const isCartPage = globalThis.location.pathname === (globalThis.Shopify?.routes?.cart || '/cart');
        if (isCartPage) {
          globalThis.dispatchEvent(new Event('theme:cart:refresh'));
        } else {
          await refreshCartDrawer();
        }
      } finally {
        refreshPending = false;
        globalThis.__ogRefreshPending = false; // allow handleCartUpdate.finally to remove overlay
      }
    })();
  }

  function tryBind(optinSelect) {
    if (!optinSelect.isConnected || !optinSelect.shadowRoot) return;
    const ogSelect = optinSelect.shadowRoot.querySelector('og-select');
    if (!ogSelect?.shadowRoot) return;
    const select = ogSelect.shadowRoot.querySelector('select');
    if (!select || select.dataset.ogBound === '1') return;
    select.dataset.ogBound = '1';
    select.addEventListener('change', onOgSelectChange);
  }

  function watchWidget(optinSelect) {
    if (optinSelect.dataset.ogWatched === '1') return;
    optinSelect.dataset.ogWatched = '1';
    let innerObserver = null;
    let trackedOgSelect = null;

    function attachToInnerShadow(ogSelect) {
      if (!ogSelect.isConnected) return;
      if (!ogSelect.shadowRoot) { requestAnimationFrame(() => attachToInnerShadow(ogSelect)); return; }
      innerObserver = new MutationObserver(() => tryBind(optinSelect));
      innerObserver.observe(ogSelect.shadowRoot, { childList: true, subtree: true });
      tryBind(optinSelect);
    }

    function setupInnerObserver(ogSelect) {
      if (ogSelect === trackedOgSelect) return; // same element — no-op
      innerObserver?.disconnect();
      trackedOgSelect = ogSelect;
      attachToInnerShadow(ogSelect);
    }

    function attachToOuterShadow() {
      if (!optinSelect.isConnected) return;
      if (!optinSelect.shadowRoot) { requestAnimationFrame(attachToOuterShadow); return; }
      new MutationObserver(() => {
        const ogSelect = optinSelect.shadowRoot?.querySelector('og-select');
        if (ogSelect) setupInnerObserver(ogSelect);
        tryBind(optinSelect);
      }).observe(optinSelect.shadowRoot, { childList: true, subtree: true });
      const ogSelect = optinSelect.shadowRoot.querySelector('og-select');
      if (ogSelect) setupInnerObserver(ogSelect);
      tryBind(optinSelect);
    }
    attachToOuterShadow();
  }
  function processAll() {
    document.querySelectorAll('og-optin-select').forEach(watchWidget);
  }
  new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('og-optin-select')) watchWidget(node);
        if (node.querySelectorAll) node.querySelectorAll('og-optin-select').forEach(watchWidget);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', processAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  // Refresh the cart drawer whenever a subscription plan changes inside the
  // cart drawer (og-offer widget), where no og-optin-select select-change fires.
  //
  // Two independent signals feed a single debounced refresh so the drawer
  // updates correctly regardless of which signal the installed OG SDK version
  // actually emits for a plan-only change:
  //   1. og:cart:updated — some OG SDK versions dispatch this for plan changes
  //   2. Fetch intercept on /cart/change.js bodies containing selling_plan —
  //      OG MUST call this endpoint to update the cart, making it 100% reliable

  let _sellingPlanRefreshTimer = null;
  function scheduleCartDrawerRefresh() {
    // onOgSelectChange manages its own refresh when the PDP widget changes.
    if (refreshPending) return;
    const isCartPage =
      globalThis.location.pathname ===
      (globalThis.Shopify?.routes?.cart || '/cart');
    // The /cart page uses the theme's own full-page refresh path.
    if (isCartPage) return;
    // Debounce: if both signals fire for the same operation, only one refresh runs.
    clearTimeout(_sellingPlanRefreshTimer);
    _sellingPlanRefreshTimer = setTimeout(refreshCartDrawer, 400);
  }

  // Signal 1: OG event (works on OG SDK versions that dispatch it for plan changes)
  globalThis.addEventListener('og:cart:updated', scheduleCartDrawerRefresh);

  // Signal 2: fetch intercept — belt-and-suspenders for SDK versions that skip
  // og:cart:updated for plan-only changes. Wraps globalThis.fetch before the
  // "Disable ATC" IIFE adds its own wrapper, so both post-processors coexist.
  (function (origFetch) {
    globalThis.fetch = async function (...args) {
      const url = args[0] instanceof Request ? args[0].url : String(args[0]);
      let isSellingPlanChange = false;
      if (url.includes('/cart/change')) {
        const init = args[1];
        if (init && typeof init.body === 'string' && init.body.includes('selling_plan')) {
          isSellingPlanChange = true;
        }
      }
      const response = await origFetch.apply(this, args);
      if (isSellingPlanChange && response.ok) {
        scheduleCartDrawerRefresh();
      }
      return response;
    };
  }(globalThis.fetch));
}());

// FOR MINI CART
(function () {
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-element');
      // Use data-view="drawer" to avoid matching the cart-page containers
      // (cart-desktop / cart-mobile) which appear earlier in the DOM on /cart.
      const currentDrawer = document.querySelector('cart-element[data-view="drawer"]');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      } else {
        console.warn('Cart drawer not found');
      }
      globalThis.dispatchEvent(new Event('theme:cart:updated'));
    } catch (e) {
      console.error('Error refreshing cart:', e);
    }
  }

  function hasSubscribeAttr(el) {
    return el.getAttributeNames().some(attr =>
      attr.toLowerCase().includes('subscribed')
    );
  }
  function addCustomClassAndUpdateQty(el) {
    const parent = el.parentElement?.parentElement;
    if (!parent) return;
    if (!parent.classList.contains('custom-qty-restrict')) {
      parent.classList.add('custom-qty-restrict');
    }
    const qtyInput = parent.querySelector('.quantity-selector--input');
    if (!qtyInput) return;
    const currentValue = Number.parseInt(qtyInput.value || 1);
    if (currentValue === 1) return;
    qtyInput.value = 1;
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    const lineKey = parent.querySelector('.cart-variant-select')?.dataset.lineKey;
    if (lineKey) {
      // API path: reliable, single server call, one refresh
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 1
        })
      })
        .then(res => res.json())
        .then(() => {
          setTimeout(refreshCartDrawer, 500);
        })
        .catch(err => console.error('Cart update error:', err));
    } else {
      // UI fallback for single-variant items that have no variant selector
      const decreaseBtn = parent.querySelector('.quantity-selector--minus');
      if (decreaseBtn) {
        let clicksNeeded = currentValue - 1;
        let i = 0;
        const interval = setInterval(() => {
          if (i >= clicksNeeded) {
            clearInterval(interval);
            return;
          }
          decreaseBtn.click();
          i++;
        }, 150);
        setTimeout(refreshCartDrawer, 500);
      }
    }
  }
  function checkAndApply(el) {
    if (hasSubscribeAttr(el)) {
      addCustomClassAndUpdateQty(el);
    }
  }
  function observeCartItem(el) {
    checkAndApply(el);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          if (hasSubscribeAttr(mutation.target)) {
            addCustomClassAndUpdateQty(mutation.target);
          }
        }
      });
    });
    observer.observe(el, {
      attributes: true,
      attributeOldValue: true
    });
  }
  function init() {
    const items = document.querySelectorAll('.cart--item og-offer');
    items.forEach(item => {
      if (!item.dataset.observed) {
        item.dataset.observed = "true";
        observeCartItem(item);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // theme:cart:updated covers post-refresh re-scans.
  // The MutationObserver is narrowed to only fire when og-offer or cart-item nodes are actually added,
  // instead of calling init() on every DOM mutation.
  globalThis.addEventListener('theme:cart:updated', init);
  const mainObserver = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && (node.matches('og-offer') || node.matches('.cart--item'))) ||
          (node.querySelectorAll && node.querySelectorAll('.cart--item og-offer').length > 0)
        ) {
          init();
          return;
        }
      }
    }
  });
  mainObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// FOR PRODUCT PAGE
(function () {
  function hasSubscribeAttr(el) {
    return el.hasAttribute('subscribed');
  }
  function applyLogic(el) {
    const parent = el.parentElement?.parentElement?.parentElement;
    if (!parent) return;
    const isSubscribed = hasSubscribeAttr(el);
    if (isSubscribed) {
      parent.classList.add('custom-qty-restrict');
      const productForm = el.closest('.product-form');
      const qtyInput = productForm?.querySelector('.quantity-selector--input');
      if (qtyInput && qtyInput.value !== "1") {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      parent.classList.remove('custom-qty-restrict');
    }
  }
  function observeWidget(el) {
    applyLogic(el);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          applyLogic(mutation.target); // ✅ always re-evaluate
        }
      });
    });
    observer.observe(el, {
      attributes: true
    });
  }
  function init() {
    const widgets = document.querySelectorAll('.product-form og-offer');
    widgets.forEach(widget => {
      if (!widget.dataset.observed) {
        widget.dataset.observed = "true";
        observeWidget(widget);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  const mainObserver = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && (node.matches('og-offer') || node.matches('.product-form'))) ||
          (node.querySelectorAll && node.querySelectorAll('.product-form og-offer').length > 0)
        ) {
          init();
          return;
        }
      }
    }
  });
  mainObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Disable add to cart ONLY if subscription version is in cart
(function () {
  const originalFetch = globalThis.fetch;
  async function updateATCButton() {
    try {
      const res = await originalFetch('/cart.js');
      const cart = await res.json();
      const atcInput = document.querySelector('input.product-buy-buttons--input');
      const atcButton = document.querySelector('.product-buy-buttons--primary[type="submit"]');
      const sellingPlanInput = document.querySelector('[name="selling_plan"]');
      if (!atcInput || !atcButton) return;
      const variantId = atcInput.dataset.id;
      const subscriptionInCart = cart.items.some(item =>
        item.variant_id == variantId &&
        item.selling_plan_allocation
      );
      const isSubscriptionSelected =
        sellingPlanInput && sellingPlanInput.value !== "";
      if (subscriptionInCart && isSubscriptionSelected) {
        atcButton.disabled = true;
        atcButton.style.opacity = '0.5';
      } else {
        atcButton.disabled = false;
        atcButton.style.opacity = '1';
      }
    } catch (e) {
      console.error('[ATC] Failed to update ATC button state:', e);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateATCButton);
  } else {
    updateATCButton();
  }
  globalThis.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0] instanceof Request ? args[0].url : String(args[0]);
    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    ) {
      updateATCButton();
    }
    return response;
  };
  // Guard: only schedule a re-check on pages that actually have the ATC button.
  // Prevents fetching /cart.js on every click across the entire site.
  document.addEventListener("click", function () {
    if (!document.querySelector('input.product-buy-buttons--input')) return;
    setTimeout(updateATCButton, 200);
  });
})();

(function () {
  function applyCustomClass() {
    const offers = document.querySelectorAll('og-offer[data-product-id]');
    const productMap = {};
    offers.forEach(function (offer) {
      const productId = offer.dataset.productId;
      const isSubscribed = offer.hasAttribute('subscribed');
      const cartItem = offer.closest('.cart--item');
      if (!productMap[productId]) {
        productMap[productId] = { oneTime: [], subscribed: [] };
      }
      if (isSubscribed) {
        productMap[productId].subscribed.push(cartItem);
      } else {
        productMap[productId].oneTime.push(cartItem);
      }
    });
    Object.keys(productMap).forEach(function (productId) {
      const data = productMap[productId];
      const hasBoth = data.oneTime.length > 0 && data.subscribed.length > 0;
      data.oneTime.forEach(function (item) {
        if (!item) return;
        if (hasBoth) {
          item.classList.add('custom-one-time-purchase');
        } else {
          item.classList.remove('custom-one-time-purchase');
        }
      });
      data.subscribed.forEach(function (item) {
        if (item) item.classList.remove('custom-one-time-purchase');
      });
    });
  }
  const restrictedOTPObserver = new MutationObserver(function () {
    applyCustomClass();
  });
  // Removed childList:true — it caused applyCustomClass() to fire on every DOM insertion site-wide.
  // theme:cart:updated handles newly rendered offer elements after cart refreshes.
  restrictedOTPObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['subscribed']
  });
  globalThis.addEventListener('theme:cart:updated', applyCustomClass);
}());

const section = document.querySelector('.kit--section');
if (section) {
  section.addEventListener('click', (e) => {
    const radio = e.target.closest('.kit--radio');
    if (!radio) return;
    const input = document.getElementById('gift-set-featured-image');
    const img = document.querySelector('[data-active="true"] modal-trigger img');
    if (input && img && input.value) {
      img.src = input.value;
      img.removeAttribute('srcset');
    }
  });
}

// Afterpay price sync
(function () {
  const optionsEl = document.querySelector('product-options-element[data-id]');
  if (!optionsEl) return;

  // KCP discount: read from the global config element (available on every page)
  const kcpEl = document.getElementById('algolia-kcp-config');
  const isKcp = kcpEl && kcpEl.dataset.enabled === 'true';
  const kcpDiscount = isKcp ? (Number.parseInt(kcpEl.dataset.discount, 10) || 15) : 0;

  function applyKcpDiscount(cents) {
    if (!isKcp || cents <= 0) return cents;
    return Math.floor(cents * (100 - kcpDiscount) / 100);
  }
  function setPrice(cents) {
    const el = document.querySelector('square-placement');
    if (el) el.dataset.amount = (applyKcpDiscount(cents) / 100).toFixed(2);
  }
  globalThis.addEventListener('theme:product:' + optionsEl.dataset.id + ':variantChanged', (e) => {
    const v = e.detail?.variant;
    if (v?.price) setPrice(v.price);
  });
  try {
    const v = JSON.parse(document.querySelector('script[id^="variant-json-"]').textContent);
    if (v?.price) setPrice(v.price);
  } catch (error_) {
    console.warn('Variant JSON is missing or malformed; skip the initial Afterpay price sync.', error_);
  }
})();

// Guard: only fetch on the cart page — avoids a wasted full-HTML request on every other page.
(function () {
  async function syncCartItemFromCartPage() {
    const _cartPath = (globalThis.Shopify?.routes?.cart) || '/cart';
    if (globalThis.location.pathname !== _cartPath) return;
    const _cartRes = await fetch('/cart');
    const _cartHtml = await _cartRes.text();
    const _cartDoc = new DOMParser().parseFromString(_cartHtml, 'text/html');
    const src = _cartDoc.querySelector('.cart--item');
    const dst = document.querySelector('.cart--item');
    if (src && dst) dst.innerHTML = src.innerHTML;
  }
  void syncCartItemFromCartPage();
})();

// Enforce max qty of 1 for subscription items in cart page
(function () {
  'use strict';
  const cartPath =
    (globalThis.Shopify?.routes?.cart) || '/cart';
  if (globalThis.location.pathname !== cartPath) return;
  let _isUpdating = false;
  function cgShowOverlay() {
    const el = document.querySelector('.cart--body');
    if (el) {
      el.classList.add('custom-overlay');
      console.log('[CG CartEnforce] Overlay ON — cart is updating');
    }
  }

  function cgHideOverlay() {
    const el = document.querySelector('.cart--body');
    if (el) {
      el.classList.remove('custom-overlay');
      console.log('[CG CartEnforce] Overlay OFF — update complete');
    }
  }
  function cgFinalize() {
    cgHideOverlay();
    _isUpdating = false;
  }
  function cgRefreshAndFinalize() {
    globalThis.dispatchEvent(new Event('theme:cart:refresh'));
    const timeout = setTimeout(function () {
      console.warn('[CG CartEnforce] theme:cart:updated not received in 3 s — finalizing anyway');
      cgFinalize();
    }, 3000);
    globalThis.addEventListener('theme:cart:updated', function () {
      clearTimeout(timeout);
      cgFinalize();
    }, { once: true });
  }

  function cgForceQty1(cartItem) {
    const qtyInput = cartItem.querySelector('.quantity-selector--input');
    const lineNum = Number.parseInt(cartItem.dataset.lineNum, 10);
    if (!qtyInput || !lineNum) return;
    const currentQty = Number.parseInt(qtyInput.value, 10);
    if (Number.isNaN(currentQty) || currentQty <= 1) {
      if (qtyInput.value !== '1') qtyInput.value = '1';
      return;
    }
    if (_isUpdating) {
      console.log('[CG CartEnforce] Update in flight — deferring (line ' + lineNum + ')');
      return;
    }
    _isUpdating = true;
    qtyInput.value = '1';
    cgShowOverlay();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineNum, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        console.log('[CG CartEnforce] API confirmed qty=1 for line ' + lineNum + ' — refreshing cart');
        cgRefreshAndFinalize();
      })
      .catch(function (err) {
        console.error('[CG CartEnforce] API error on line ' + lineNum + ':', err);
        cgFinalize(); // always clear overlay so cart stays usable
      });
  }
  function cgCheckItem(cartItem) {
    if (!cartItem) return;
    const ogOffer = cartItem.querySelector('og-offer[data-product-id]');
    if (!ogOffer) return;                          // no OG widget — skip
    if (!ogOffer.hasAttribute('subscribed')) return; // one-time purchase — skip
    cgForceQty1(cartItem);
  }
  function cgObserveOffer(offerEl) {
    if (offerEl.dataset.cgWatched === '1') return;
    offerEl.dataset.cgWatched = '1';
    cgCheckItem(offerEl.closest('.cart--item'));
    new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          console.log(
            '[CG CartEnforce] og-offer attr "' + mutation.attributeName +
            '" changed — re-evaluating item'
          );
          cgCheckItem(offerEl.closest('.cart--item'));
          break;
        }
      }
    }).observe(offerEl, { attributes: true });
  }
  function cgScan() {
    const offers = document.querySelectorAll('.cart--item og-offer[data-product-id]');
    console.log('[CG CartEnforce] scan() — ' + offers.length + ' og-offer(s)');
    offers.forEach(cgObserveOffer);
  }
  document.addEventListener('click', function (e) {
    const plusBtn = e.target.closest?.('.quantity-selector--plus');
    if (!plusBtn) return;
    const cartItem = plusBtn.closest('.cart--item');
    if (!cartItem?.querySelector('og-offer[subscribed]')) return;
    e.preventDefault();
    e.stopPropagation();
    console.log(
      '[CG CartEnforce] + click blocked — subscription item (variant ' +
      (cartItem.dataset.variantId || '?') + ')'
    );
  }, true /* capture */);
  function cgClampInput(e) {
    const input = e.target;
    if (!input?.classList.contains('quantity-selector--input')) return;
    const cartItem = input.closest?.('.cart--item');
    if (!cartItem?.querySelector('og-offer[subscribed]')) return;

    const val = Number.parseInt(input.value, 10);
    if (!Number.isNaN(val) && val > 1) {
      input.value = '1';
      console.log(
        '[CG CartEnforce] Input clamped → 1 (variant ' +
        (cartItem.dataset.variantId || '?') + ')'
      );
    }
  }
  document.addEventListener('input', cgClampInput, true /* capture */);
  document.addEventListener('change', cgClampInput, true /* capture */);
  new MutationObserver(function (mutations) {
    let needsScan = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && (
            node.matches('og-offer') ||
            node.matches('.cart--item') ||
            node.matches('.cart--item-details')
          )) ||
          (node.querySelectorAll && node.querySelectorAll('og-offer[data-product-id]').length > 0)
        ) {
          needsScan = true;
          break;
        }
      }
      if (needsScan) break;
    }
    if (needsScan) {
      console.log('[CG CartEnforce] Relevant DOM change — re-scanning');
      cgScan();
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cgScan);
  } else {
    cgScan();
  }
  document.addEventListener('shopify:section:load', cgScan);
}());

// FOR MINI CART - Hide promo form if subscription is added
(function () {
  'use strict';
  let _removingPromo = false;
  function autoRemovePromoForSubscription() {
    if (_removingPromo) return;
    const removeBtn = document.querySelector('#shopify-section-cart-drawer .removePromo-btn');
    if (!removeBtn || removeBtn.style.display === 'none') return;
    _removingPromo = true;
    document.body.classList.add('cart-loading');
    removeBtn.click();
    globalThis.addEventListener('theme:cart:updated', function () {
      _removingPromo = false;
      document.body.classList.remove('cart-loading');
    }, { once: true });
  }
  function applyHidePromoState() {
    const cartEl = document.querySelector('#shopify-section-cart-drawer cart-element');
    if (!cartEl) return;
    const body = cartEl.querySelector('.cart--body.custom-cart-body');
    const hasSubscribed = !!body && !!body.querySelector('og-offer[subscribed]');
    cartEl.classList.toggle('hide-promo', hasSubscribed);
    if (hasSubscribed) {
      autoRemovePromoForSubscription();
    }
  }
  globalThis.addEventListener('theme:cart:updated', applyHidePromoState);
  if (!globalThis._hidePromoObserverAttached) {
    globalThis._hidePromoObserverAttached = true;
    new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.target.nodeName.toLowerCase() === 'og-offer'
        ) {
          applyHidePromoState();
          return;
        }
      }
    }).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['subscribed']
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHidePromoState);
  } else {
    applyHidePromoState();
  }
}());